export enum StatusBdp {
  ACTIVE = 'global.bdp-status.active',
  NOT_ACTIVE = 'global.bdp-status.not-active',
  DRAINING = 'global.bdp-status.draining',
  UNKNOWN = 'global.bdp-status.unknown',
  CREATING = 'global.bdp-status.creating',
  STARTING = 'global.bdp-status.starting',
}
